"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var InPlaceReplacement_1 = require("./InPlaceReplacement");
var ChannelUtil_1 = require("@CommonFrontendBackend/Utils/PusherChannelUtil/ChannelUtil");
var ProjectCollaborationTypes_1 = require("@CommonFrontendBackend/Collaboration/ProjectCollaborationTypes");
var LockOrchestrator_1 = require("./LockOrchestrator");
var Collaboration = (function () {
    function Collaboration($state, $http, pusher, environment, notifyUser, apiBaseUrl, user, project, projectStatusChecker, showAcknowledgeModal, projectEvents, blockList, createUi, activeUserStore, projectStore) {
        var _this = this;
        this.$state = $state;
        this.$http = $http;
        this.pusher = pusher;
        this.environment = environment;
        this.notifyUser = notifyUser;
        this.apiBaseUrl = apiBaseUrl;
        this.user = user;
        this.project = project;
        this.projectStatusChecker = projectStatusChecker;
        this.showAcknowledgeModal = showAcknowledgeModal;
        this.projectEvents = projectEvents;
        this.blockList = blockList;
        this.createUi = createUi;
        this.activeUserStore = activeUserStore;
        this.projectStore = projectStore;
        this.channel = null;
        this.projectWasDeleted = false;
        this.subscribe = function ($scope) {
            _this.channel = _this.pusher.subscribe(_this.channelName);
            $scope.$on("$destroy", _this.unsubscribe);
            _this.channel.bind("pusher:subscription_succeeded", function () {
                return _this.$http.post("".concat(_this.apiBaseUrl, "/projects/").concat(_this.project._id, "/opened"));
            });
            _this.channel.bind("project_accepted", function (data) { return $scope.$apply(_this.projectAccepted(data)); });
            _this.channel.bind("pusher:subscription_error", _this.subscriptionError);
            _this.channel.bind(ProjectCollaborationTypes_1.ProjectCollaborationEvent.Project_Opened, function (data) { return $scope.$apply(_this.projectOpened(data)); });
            _this.channel.bind("client-project_left", function (data) { return $scope.$apply(_this.projectLeft(data)); });
            _this.channel.bind(ProjectCollaborationTypes_1.ProjectCollaborationEvent.Project_Updated, function (data) { return $scope.$apply(_this.projectUpdated(data)); });
            _this.channel.bind(ProjectCollaborationTypes_1.ProjectCollaborationEvent.Project_Deleted, function (data) { return $scope.$apply(_this.projectDeleted(data)); });
            _this.channel.bind(ProjectCollaborationTypes_1.ProjectCollaborationEvent.Project_Sort_Changed, function (data) {
                return $scope.$apply(_this.projectBlockSortChanged(data));
            });
            _this.channel.bind(ProjectCollaborationTypes_1.BlockCollaborationEvent.Block_Locked, function (data) { return $scope.$apply(_this.blockLocked(data)); });
            _this.channel.bind(ProjectCollaborationTypes_1.BlockCollaborationEvent.Block_Updated, function (data) { return $scope.$apply(_this.blockUpdated(data)); });
            _this.channel.bind(ProjectCollaborationTypes_1.BlockCollaborationEvent.Block_Deleted, function (data) { return $scope.$apply(_this.blockDeleted(data)); });
            _this.handleCollaboration();
            _this.startWatchingFocusChanges($scope);
        };
        this.unsubscribe = function () {
            var userName = _this.user.firstName;
            if (_this.user.lastName != null ? _this.user.lastName.length : undefined) {
                userName += " ".concat(_this.user.lastName);
            }
            if (!!_this.channel) {
                if (!_this.projectWasDeleted) {
                    _this.channel.trigger("client-project_left", {
                        userName: userName,
                        userId: _this.user._id,
                    });
                }
                _this.channel.unbind();
                _this.channel = null;
            }
            _this.pusher.unsubscribe(_this.channelName);
            _this.unsubscribeAllBlockChannel();
            _this.activeUserStore.clearAll();
            _this.projectStore.clearAllLockedBlocks();
            return _this.stopWatchingFocusChanges();
        };
        this.isBlockLocked = function (block) {
            var unlockTime = Date.now() - 15000;
            var blockIsLockedByOtherUser = block.lock != null && block.lock.userId !== _this.user._id;
            var blockIsLocked = blockIsLockedByOtherUser && block.lock.timestamp >= unlockTime;
            return blockIsLocked;
        };
        this.startWatchingFocusChanges = function ($scope) {
            if (!_this.projectStore.isEditable) {
                return;
            }
            var focusedElement = null;
            _this.focusInterval = window.setInterval(function () {
                if (document.activeElement !== focusedElement) {
                    focusedElement = document.activeElement;
                    _this.focusedElementChanged();
                }
                $scope.$apply(_this.unlockBlocks);
            }, 200);
        };
        this.stopWatchingFocusChanges = function () {
            clearInterval(_this.focusInterval);
            _this.focusInterval = undefined;
            _this.lockOrchestrator.clearLock();
        };
        this.focusedElementChanged = function () {
            _this.lockOrchestrator.clearLock();
            var block = _this.getFocusedBlock();
            if (block != null && !_this.isBlockLocked(block)) {
                _this.lockBlock(block._id);
                _this.lockOrchestrator.enableLock(function () {
                    return _this.lockBlock(block._id);
                });
            }
        };
        this.getFocusedBlock = function () {
            if (!document.activeElement) {
                return null;
            }
            var blockWrapper = $(document.activeElement).closest(".top-level-block-wrapper");
            if (!blockWrapper.length) {
                return null;
            }
            var blockId = blockWrapper.data("id");
            if (!blockId) {
                return null;
            }
            return lodash_1.default.find(_this.project.blocks, { _id: blockId });
        };
        this.lockBlock = function (blockId) {
            return _this.$http.post("".concat(_this.apiBaseUrl, "/projects/").concat(_this.project._id, "/blocks/").concat(blockId, "/lock"));
        };
        this.unlockBlocks = function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.project.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var block = _c.value;
                    if (!_this.isBlockLocked(block)) {
                        block.lock = null;
                        _this.projectStore.removeLockedBlock(block._id);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.subscriptionError = function (status) {
            _this.notifyUser.error("A network error occurred.");
        };
        this.projectOpened = function (data) {
            var actionName = data.canEdit ? "editing" : "viewing";
            _this.notifyUser.note("".concat(data.userFirstName, " is now ").concat(actionName, " this page."));
            _this.activeUserStore.addUser(data.userId);
            if (data.userId === _this.user._id) {
                _this.$state.go("dashboard", { nav: "pages" });
                return _this.showAcknowledgeModal({
                    title: "'".concat(_this.project.name, "' has been opened elsewhere"),
                    explainer: "If you'd like to collaborate, invite your team to your account and work on the same document at the same time.",
                    button: "Invite Team",
                }).then(function (result) {
                    if (result) {
                        return _this.$state.go("settings", { section: "users" });
                    }
                });
            }
        };
        this.projectLeft = function (data) {
            var e_2, _a;
            _this.notifyUser.note("".concat(data.userName, " stopped editing this page."));
            _this.activeUserStore.removeUser(data.userId);
            try {
                for (var _b = __values(_this.project.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var block = _c.value;
                    if ((block.lock != null ? block.lock.userId : undefined) === data.userId) {
                        block.lock = null;
                        _this.projectStore.removeLockedBlock(block._id);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        this.projectBlockSortChanged = function (data) {
            _this.blockList.refreshOrder(data.newPersistVersion, data.sortOrder);
        };
        this.blockLocked = function (data) {
            var e_3, _a;
            var block;
            if (!data.blockId || !data.socketId || !data.userFirstName) {
                return;
            }
            try {
                for (var _b = __values(Array.from(_this.project.blocks)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    block = _c.value;
                    if (block._id !== data.blockId && (block.lock != null ? block.lock.userId : undefined) === data.userId) {
                        block.lock = null;
                        block.$skipPersistenceCycle = false;
                        _this.projectStore.removeLockedBlock(block._id);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            block = lodash_1.default.find(_this.project.blocks, { _id: data.blockId });
            if (!block) {
                return;
            }
            _this.activeUserStore.addUser(data.userId);
            block.lock = {
                socketId: data.socketId,
                userId: data.userId,
                userFirstName: data.userFirstName,
                userLastName: data.userLastName,
                timestamp: Date.now(),
            };
            _this.projectStore.addLockedBlock(block._id);
            return _this.projectEvents.emit("bigComponentOpened", { openedByCollaborator: true, blockId: block._id });
        };
        this.projectUpdated = function (data) {
            if (!data.project) {
                return;
            }
            lodash_1.default.merge(_this.project, data.project, { $skipPersistenceCycle: true });
            if (!_this.projectStatusChecker.isEditable(_this.project)) {
                _this.showAcknowledgeModal({
                    title: "Project can no longer be edited",
                    explainer: "".concat(data.userFirstName, " changed the status of the project and it can no longer be edited."),
                });
                return _this.$state.go("dashboard", { nav: "pages" });
            }
        };
        this.projectDeleted = function (data) {
            var firstName = data.userFirstName;
            var link = "https://help.qwilr.com/article/236-how-do-i-restore-a-deleted-qwilr-page";
            var deletedHtml = _this.createUi(require("./CannotOpenDeletedQwilr.html"), { firstName: firstName, link: link });
            _this.projectWasDeleted = true;
            _this.$state.go("dashboard", { nav: "pages" });
            return _this.showAcknowledgeModal({
                title: "Looks like this page has been deleted",
                explainer: deletedHtml,
                button: "Got it",
            });
        };
        this.projectAccepted = function (data) {
            _this.$state.go("dashboard", { nav: "pages" });
            return _this.showAcknowledgeModal({
                title: "Project has been accepted",
                explainer: "".concat(data.accepterName, " has accepted the project. It can no longer be edited"),
            });
        };
        this.blockUpdated = function (data) {
            if (!data.blockId || !data.block) {
                return;
            }
            delete data.block.lock;
            var blockIndex = lodash_1.default.findIndex(_this.project.blocks, { _id: data.blockId });
            _this.activeUserStore.addUser(data.userId);
            if (blockIndex >= 0) {
                if (data.block.persistVersion <= _this.project.blocks[blockIndex].persistVersion) {
                    return;
                }
                data.block.$collabUpdated = true;
                (0, InPlaceReplacement_1.inPlaceReplacement)(_this.project.blocks[blockIndex], data.block, { $skipPersistenceCycle: true });
                if (_this.project.blocks[blockIndex].$triggerLoad != null) {
                    return _this.project.blocks[blockIndex].$triggerLoad();
                }
            }
            else {
                data.block.$collabCreated = true;
                data.block.$scrollTo = false;
                if (data.block.type !== "Agreement") {
                    var blockPosition = data.blockPosition || 0;
                    _this.blockList.addBlock(data.block, blockPosition, { skipPersistance: true, skipScrolling: true });
                }
                return _this.notifyUser.note("".concat(data.userFirstName, " added a block."));
            }
        };
        this.blockDeleted = function (data) {
            if (!data.blockId) {
                return;
            }
            var block = lodash_1.default.find(_this.project.blocks, { _id: data.blockId });
            _this.activeUserStore.addUser(data.userId);
            if (block != null) {
                block.$collabDeleted = true;
                _this.blockList.removeBlock(block, true);
                return _this.notifyUser.note("".concat(data.userFirstName, " deleted a block."));
            }
        };
        this.unsubscribeByBlock = function (blockId) {
            var blockChannelName = (0, ChannelUtil_1.buildChannelName)(_this.project._id, blockId);
            _this.pusher.unsubscribe(blockChannelName);
        };
        this.unsubscribeAllBlockChannel = function () {
            _this.project.blocks.forEach(function (block) {
                _this.unsubscribeByBlock(block._id);
            });
        };
        this.channelName = (0, ChannelUtil_1.buildChannelName)(project._id);
        this.lockOrchestrator = new LockOrchestrator_1.LockOrchestrator();
    }
    Collaboration.prototype.handleCollaboration = function () {
        var e_4, _a;
        var _this = this;
        var otherCollaboratorNames = [];
        var otherCollaboratorIds = [];
        try {
            for (var _b = __values(this.project.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var block = _c.value;
                var lockedByOtherUser = block.lock != null && block.lock.userId !== this.user._id;
                if (lockedByOtherUser && !otherCollaboratorNames.includes(block.lock.userFirstName)) {
                    otherCollaboratorNames.push(block.lock.userFirstName);
                    otherCollaboratorIds.push(block.lock.userId);
                    this.projectStore.addLockedBlock(block._id);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        if (otherCollaboratorNames.length > 0) {
            var otherCollaboratorsList = otherCollaboratorNames.join(", ");
            this.notifyUser.note("This page is also being edited by ".concat(otherCollaboratorsList));
            otherCollaboratorIds.forEach(function (userId) {
                _this.activeUserStore.addUser(userId);
            });
        }
    };
    return Collaboration;
}());
exports.default = Collaboration;
